import { put, select } from "redux-saga/effects";
import { onInviteAction } from "../onInvite/action";
import { onConnectAction } from "../onConnect/action";
import { onDisconnectAction } from "../onDisconnect/action";
import { attemptReconnectAction } from "../attemptReconnect/action";
import { setUA } from "../../../state/userAgent/userAgentSlice";
import { selectDevice } from "../../../state/device/deviceSlice";
import { selectLogin } from "../../../state/login/loginSlice";
import { selectWsServers } from "../../../state/config/configSlice";
import store from "../../../state/store";
import { UserAgent } from "sip.js";

export function* initUASaga() {
    const { DeviceUser, Pass, Realm } = yield select(selectDevice)
    const { isLoggedIn } = yield select(selectLogin);
    const wsServers = yield select(selectWsServers);
    const UserAgentOptions = {
        uri: UserAgent.makeURI(`sip:${DeviceUser}@${Realm}`),
        transportOptions: {
            // traceSip: true,
            traceSip: false,
            server: wsServers[0],
        },
        authorizationUsername: DeviceUser,
        authorizationPassword: Pass,
        // logLevel: 'debug',
        logLevel: 1,
        register: true,
        sessionDescriptionHandlerFactoryOptions: {
            iceGatheringTimeout: 500, 
        },
        delegate: {
            onInvite: (invitation) => {
                console.debug('onInvite', invitation);
                store.dispatch(onInviteAction(invitation))
            },
            onConnect: () => {
                console.debug('calling onConnect', Date.now());
                store.dispatch(onConnectAction())
            },
            onDisconnect: (error) => {
                console.debug(Date.now(), 'calling onDisconnect', error);
                store.dispatch(onDisconnectAction(error))
            },

        },
    };
    let ua;
    try {
        console.log('Trying to start UA')
        ua = new UserAgent(UserAgentOptions);
        yield put(setUA(ua));
        yield ua.start();

        // Event Listener when networks get's reconnected.
        // window.addEventListener('online', () => {
        //     if (isLoggedIn) {
        //         console.debug('Network came back online. Attempting to reconnect.');
        //         store.dispatch(showSnackbar({
        //             message: "Network came back online. Attempting to reconnect.",
        //             severity: "success"
        //         }))
        //     }
        //     // TODO: store.dispatch(attemptReconnectAction()); //Note this needs to be uncommented to start reconnection. Also implement MAX_RECONNECTION_ATTEMPTS logic in attemptReconnect saga.
        // });

    } catch (e) {
        console.error('Failed to Connect', e);
        yield put(setUA(ua));
        console.log('We hit attemptReconnect from initUA', Date.now())
        yield put(attemptReconnectAction());

    }
}